import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
import { renderFormattedText } from "Lib/text-utils";
import styles from "Styles/CompanySize.module.css";
import emoji from "Assets/emoji/shocked.svg";

const MarketingPainPointsInfoContent = ({ heading }) => {
  return (
    <InfoContentMotionWrapper>
      <h3 className={styles.heading}>{renderFormattedText(heading)}</h3>
      <div className={styles.decorativeElements}>
        <img
          src={emoji}
          alt="Shocked Emoji"
          className={styles.emoji}
          style={{ marginTop: "60px" }}
        />
      </div>
    </InfoContentMotionWrapper>
  );
};

export default MarketingPainPointsInfoContent;
